module.exports = __webpack_public_path__ + "media/images/kds/KDS2-12bf7bfe699120bebb677ba6df927513.svg";